// extracted by mini-css-extract-plugin
var _1 = "SDGygJbWrRupkWggMECa";
var _2 = "fwlZe5RjuPVbdTYsyWzu";
var _3 = "CbCrs9Drh2siPrEbh8MJ";
export { _1 as "menuItem", _2 as "menuWrapper", _3 as "toggleButton" }
